var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { EventCountModalData } from './event.count.modal.provider';
var EventCountModalComponent = /** @class */ (function (_super) {
    __extends(EventCountModalComponent, _super);
    function EventCountModalComponent(accountApiService, alertify, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.dialogRef = dialogRef;
        _this.data = data;
        _this.loading = false;
        _this.savingContract = false;
        _this.tiers = [];
        _this.contract = {};
        _this.periodType = 'contract';
        _this.error = '';
        _this.sourceKeys = ['facebook', 'eventbrite', 'serpGoogle', 'aiAggregator'];
        return _this;
    }
    EventCountModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.accountApiService.getEventSubscriptionTiers().subscribe(function (tiers) {
            _this.tiers = tiers || [];
            _this.loadContractAndCount();
        }, function () { return _this.loadContractAndCount(); });
    };
    EventCountModalComponent.prototype.loadCount = function (year) {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.accountApiService.getEventCount(this.data.account.userName, this.periodType, year)
            .finally(function () { return _this.loading = false; })
            .subscribe(function (count) {
            _this.count = count;
            _this.selectedYear = count.deliveryStatistics.period.anchorYear;
        }, function (error) {
            _this.error = error && error.error && error.error.message
                ? error.error.message
                : 'Could not load event delivery statistics.';
        });
    };
    EventCountModalComponent.prototype.changePeriod = function () {
        this.selectedYear = null;
        this.loadCount();
    };
    EventCountModalComponent.prototype.changeYear = function () {
        this.loadCount(this.selectedYear);
    };
    EventCountModalComponent.prototype.saveContract = function () {
        var _this = this;
        if (!this.contract.subscriptionTierId || !this.contract.contractStartDate) {
            this.alertify.error('Select a subscription tier and contract start date.');
            return;
        }
        this.savingContract = true;
        this.accountApiService.saveEventContract(this.data.account.userName, {
            subscriptionTierId: this.contract.subscriptionTierId,
            contractStartDate: this.contract.contractStartDate,
        }).finally(function () { return _this.savingContract = false; }).subscribe(function (contract) {
            _this.contract = contract;
            _this.contract.contractStartDate = _this.toDateInput(contract.contractStartDate);
            _this.periodType = 'contract';
            _this.alertify.successfully('Event contract settings saved.');
            _this.loadCount();
        });
    };
    EventCountModalComponent.prototype.displayRun = function (run) {
        return run && run.completedAt ? new Date(run.completedAt).toLocaleString() : 'N/A';
    };
    EventCountModalComponent.prototype.duration = function (ms) {
        if (ms === null || ms === undefined)
            return 'N/A';
        var seconds = Math.round(ms / 1000);
        if (seconds < 60)
            return seconds + "s";
        var minutes = Math.floor(seconds / 60);
        return minutes + "m " + seconds % 60 + "s";
    };
    EventCountModalComponent.prototype.sourceName = function (key) {
        return ({ facebook: 'Facebook', eventbrite: 'Eventbrite', serpGoogle: 'Serp Google', aiAggregator: 'AI Event Aggregator' })[key] || key;
    };
    EventCountModalComponent.prototype.reportingYearLabel = function (year) {
        if (this.periodType !== 'contract' || !this.contract.contractStartDate)
            return String(year);
        var dateParts = String(this.contract.contractStartDate).split('-');
        var startMonth = Number(dateParts[1]);
        if (!Number.isInteger(startMonth) || startMonth < 1 || startMonth > 12)
            return String(year);
        var endMonth = startMonth === 1 ? 12 : startMonth - 1;
        var endYear = startMonth === 1 ? Number(year) : Number(year) + 1;
        return year + "." + startMonth + " - " + endYear + "." + endMonth;
    };
    EventCountModalComponent.prototype.alertStatus = function (threshold) {
        var contract = this.count && this.count.deliveryStatistics
            ? this.count.deliveryStatistics.contract
            : null;
        var alerts = contract && contract.alerts ? contract.alerts : [];
        var alert = alerts.find(function (item) { return item.threshold === threshold; });
        if (alert) {
            return alert.status === 'sent' && alert.sentAt
                ? "sent " + new Date(alert.sentAt).toLocaleString()
                : alert.status;
        }
        var reached = contract && (threshold === 70
            ? contract.reached70Percent
            : contract.reached100Percent);
        return reached ? 'pending' : 'not reached';
    };
    EventCountModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    EventCountModalComponent.prototype.toDateInput = function (value) {
        var date = new Date(value);
        return isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
    };
    EventCountModalComponent.prototype.loadContractAndCount = function () {
        var _this = this;
        this.accountApiService.getEventContract(this.data.account.userName).subscribe(function (contract) {
            _this.contract = contract || {};
            if (_this.contract.contractStartDate) {
                _this.contract.contractStartDate = _this.toDateInput(_this.contract.contractStartDate);
            }
            else {
                _this.periodType = 'calendar';
            }
            _this.loadCount();
        }, function () {
            _this.periodType = 'calendar';
            _this.loadCount();
        });
    };
    return EventCountModalComponent;
}(BaseComponent));
export { EventCountModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.count/event.count.modal.component.ts.pre-build-optimizer.js